import { AuthApiService } from '@admin/core';
import { Component, effect, inject, input, signal } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ENVIRONMENT } from '@controladad/ng-base';
import { take } from 'rxjs';

@Component({
  selector: 'app-image-viewer',
  imports: [],
  templateUrl: './image-viewer.component.html',
})
export class ImageViewerComponent {
  private sanitizer = inject(DomSanitizer);
  private readonly authApi = inject(AuthApiService);
  private readonly env = inject(ENVIRONMENT);

  imageUrl = input<string>();
  label = input<string>('عکس');

  hasError = signal<boolean>(false);
  isExpanded = signal<boolean>(false);
  imageSrc = signal<SafeUrl | string | null>(null);
  isLoading = signal<boolean>(false);


  constructor() {
    effect(() => {
      const url = this.imageUrl();
      if (url && url.startsWith(this.env.apiBaseUrl)) {
        this.downloadImage(url);
      } else if (url) {
        this.imageSrc.set(url);
        this.hasError.set(false);
      } else {
        this.imageSrc.set(null);
        this.hasError.set(false);
      }
    });
  }

  onImageError(): void {
    this.hasError.set(true);
    this.isLoading.set(false);
  }

  toggleExpand(): void {
    this.isExpanded.update(value => !value);
  }

  private downloadImage(url: string): void {
    this.isLoading.set(true);
    this.authApi.downloadImage(url).pipe(take(1)).subscribe({
      next: (blob) => {
        const objectURL = URL.createObjectURL(blob);
        this.imageSrc.set(this.sanitizer.bypassSecurityTrustUrl(objectURL));
        this.hasError.set(false);
        this.isLoading.set(false);
      },
      error: (error) => {
        console.error('Failed to load image:', error);
        this.hasError.set(true);
        this.isLoading.set(false);
      }
    });
  }

}
